var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"img-slider-bg-index"},[_c('div',{staticClass:"popup"},[_vm._t("default")],2),(_vm.button && _vm.onClick)?_c('button',{staticClass:"theme-button-primary",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.button)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }